import TagManager from "react-gtm-module";

function ExploreCollegesType({ ipeds }) {
  const tagManagerArgs = {
    dataLayer: {
      event: "interactionEvent",
      eventName: "explore_colleges_type",
      ipeds: ipeds,
    },
  };

  TagManager.dataLayer(tagManagerArgs);
}

export default ExploreCollegesType;
